import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmInputComponent } from './components/confirm-input/confirm-input.component';
import { NumberInputComponent } from './components/number-input/number-input.component';
import { StringInputComponent } from './components/string-input/string-input.component';
import { DoubleInputComponent } from './components/double-input/double-input.component';
import { DialogInputService } from './dialog-input.service';
import { IonicModule } from '@ionic/angular';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedDirectivesModule } from 'src/app/shared/directives/shared-directives.module';
import { MultiDaySettingsInputComponent } from './components/multi-day-settings-input/multi-day-settings-input.component';
import { NgxMaterialIntlTelInputComponent } from 'ngx-material-intl-tel-input'

@NgModule({
    declarations: [
        ConfirmInputComponent,
        NumberInputComponent,
        StringInputComponent,
        DoubleInputComponent,
        MultiDaySettingsInputComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MatButtonModule,
        MatDialogModule,
        MatInputModule,
        MatFormFieldModule,
        SharedDirectivesModule,
        NgxMaterialIntlTelInputComponent,
        ReactiveFormsModule,
    ],
    providers: [DialogInputService],
    exports: [SharedDirectivesModule],
})
export class DialogInputModule {}
